<template>
  <TimeEntryPopover
    :users="users"
    :type="type"
    :sub-type="subType"
    :initial-date="initialDate"
    :new-entry="newEntry"
    v-on="$listeners"
    :week-dates="weekDates"
    :is-read-only="isReadOnly"
  >
    <template #trigger>
      <ButtonView
        class="is-light"
        type="is-primary"
        icon-pack="cls cls-time-clock-circle"
        icon-left="time-clock-circle"
        :loading="isLoading"
        :disabled="disabled"
      >
        <p>{{ buttonLabel }}</p>
      </ButtonView>
    </template>
  </TimeEntryPopover>
</template>

<script>
import { UserCollection } from '@/modules/user/models/UserCollection';
import UserTimeEntryService from '@/modules/user/services/UserTimeEntryService';
import TimeEntryPopover from '@/modules/timeentry/components/presentational/TimeEntryPopover.vue';
import { TimeEntry } from '@/modules/timeentry/models/TimeEntry';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TimeEntryButton',
  components: { ButtonView, TimeEntryPopover },
  props: {
    queryParams: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      required: true
    },
    subType: {
      type: String,
      default: null
    },
    initialDate: {
      type: Date
    },
    usersToDisplay: {
      type: Array
    },
    newEntry: {
      type: TimeEntry
    },
    weekDates: {
      type: Array,
      default: () => []
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      users: UserCollection.mapModel([]),
      isLoading: false
    };
  },
  computed: {
    buttonLabel() {
      return this.users.totalTimeEntriesFormatted;
    }
  },
  methods: {
    async init() {
      if (this.usersToDisplay) {
        this.users = UserCollection.mapModel(this.usersToDisplay);

        return;
      }

      try {
        this.isLoading = true;
        const users = await UserTimeEntryService.getEntitiesWithoutUserEstateScope(
          this.queryParams
        );
        this.users = UserCollection.mapModel(users);
      } finally {
        this.isLoading = false;
      }
    }
  },
  watch: {
    weekDates: {
      immediate: true,
      handler() {
        this.init();
      }
    }
  }
};
</script>

<style scoped>
button {
  padding: var(--ce-3px) var(--ce-8px);
  font-size: var(--ce-14px);
  height: var(--ce-32px);
  width: var(--ce-90px);
  text-align: left;
}

button :deep(.icon) {
  font-size: var(--ce-18px);
  font-weight: var(--ce-weight-semibold);
}
</style>
